const data = [
  {
    title: '产融管理运营平台',
    subtitle: 'CMP',
    type: 'cmp',
    desc: '主要服务于产业平台和有产融管理运营需求的企业，实现对上下游小微企业线上化产融管理'
  },
  {
    title: '跨境经营评估平台',
    subtitle: 'FAP',
    type: 'fap',
    desc: '致力于为跨境电商企业提供更可控、更高效、更具性价比的关、税申报一体化SaaS服务和数字化供应链金融解决方案'
  },
  {
    title: '产融方案设计平台',
    subtitle: "SRP",
    type: 'srp',
    desc: '主要服务于资金机构，涵盖金融方案设计功能、产业监控方案推荐功能、明心项目推荐功能'
  },
  {
    title: '经营评估平台',
    subtitle: 'OAP',
    type: 'oap',
    desc: '集合丰富的产业链数据，帮助银行、供应链金融、中小微企业提供智能、高效的产业经营评估方案'
  },
  {
    title: '产业物联网平台',
    subtitle: 'IMP',
    type: 'imp',
    desc: '安全可靠的设备连接，支持IoT数据采集，流转数据。也支持远程调试、监控等设备管理能力'
  },
  {
    title: '产业区块链平台',
    subtitle: 'BMP',
    type: 'bmp',
    desc: '为企业及其合作伙伴提供便利的高可用区块链服务，使得符合区块链应用场景的业务在区块链侧获得有效的身份证书管理、链码可视化部署、监控预警、数据隐私安全等关键动力'
  }
]

export default data